import useRelatedProducts from './useRelatedProducts';

import type { ProductData } from '@Types/Product';

const useSortedRelatedProductsBy = (field: keyof ProductData, id: number) => {
  const { data: relatedProducts } = useRelatedProducts(id);

  return relatedProducts?.products.filter((product) => product[field]);
};

export default useSortedRelatedProductsBy;
